var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 63,
    viewBox: "0 0 121 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_388_6421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 95,
    height: 38
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_6421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 12H31.4907V14.6004H13V12Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0155 12H54.7076L55.3606 12.1045L56.0004 12.2221L56.6664 12.3659L57.3193 12.588L57.92 12.8232L58.5207 13.1238L59.1344 13.4374L59.6829 13.8294L60.2313 14.2084L60.6362 14.6004H34.1406V12H54.0155Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8477 12H80.8779L81.805 14.6004H65.8477V12Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0996 12H107.999V14.6004H92.1855L93.0996 12Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.0703H31.4907V19.6446H13V17.0703Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 22.1011H26.1894V24.7146H18.2891V22.1011Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 27.1318H26.1894V29.7584H18.2891V27.1318Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5035 17.0703L62.6472 17.3186L62.9475 17.9328L63.1825 18.5992L63.496 19.6446H34.1406V17.0703H62.5035Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4297 22.1011H47.33V24.7146H39.4297V22.1011Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7451 22.1011L63.7189 22.5062L63.6537 23.1857L63.5492 23.839L63.3794 24.4924L63.3141 24.7146H55.2832V22.1011H63.7451Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1905 27.1318L61.9424 27.5108L61.5376 28.0466L61.1067 28.5431L60.6366 29.0266L60.1273 29.4709L59.6833 29.7584H39.4297V27.1318H62.1905Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8477 17.0703H82.6538L83.5679 19.6446H65.8477V17.0703Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 17.0703V19.6446H90.4355L91.3235 17.0703H107.999Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1367 22.1011H84.4041L85.3182 24.7146H71.1367V22.1011Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.842 22.1011V24.7146H88.6602L89.5612 22.1011H102.842Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8989 29.7584H94.1195L94.9161 27.4324V29.7584H102.843V27.1318H87.8254L86.9896 29.4709L86.167 27.1318H71.1367V29.7584H79.0632V27.4063L79.8989 29.7584Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 47.3604H31.4907V50H13V47.3604Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 42.2773H31.4907V44.917H13V42.2773Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 32.2153H26.1894V34.8027H18.2891V32.2153Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 37.2461H26.1894V39.8726H18.2891V37.2461Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6833 32.2153L60.1273 32.529L60.6366 32.9602L61.1067 33.4567L61.5376 33.9533L61.9424 34.5021L62.1905 34.8027H39.4297V32.2153H59.6833Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4297 37.2461H47.33V39.8726H39.4297V37.2461Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3141 37.2461L63.3794 37.5074L63.5492 38.1608L63.6537 38.8011L63.7189 39.4806L63.7451 39.8726H55.2832V37.2461H63.3141Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.496 42.2773L63.3784 42.8131L63.1825 43.4403L62.9475 44.0676L62.6472 44.6817L62.5035 44.917H34.1406V42.2773H63.496Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6362 47.3604L60.1269 47.7785L59.5915 48.1967L59.043 48.5626L58.4423 48.8762L57.8286 49.1767L57.2279 49.4119L56.5619 49.6341L55.909 49.7778L55.2822 49.8954L54.6032 49.9738L53.9241 50H34.1406V47.3604H60.6362Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1367 32.2153H79.0632V34.8027H71.1367V32.2153Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3551 34.8027H81.6081L80.707 32.2153H93.2692L92.3551 34.8027Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.916 32.2153H102.842V34.8027H94.916V32.2153Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1367 37.2461H79.0632V39.8726H71.1367V37.2461Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5595 37.2461L90.6454 39.8726H83.3327L82.4316 37.2461H91.5595Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.916 37.2461H102.842V39.8726H94.916V37.2461Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8477 42.2773H79.0628V44.917H65.8477V42.2773Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8236 42.2773L88.9356 44.917H85.0573L84.1562 42.2773H89.8236Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.916 42.2773H108.001V44.917H94.916V42.2773Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8477 47.3604H79.0628V50H65.8477V47.3604Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.916 47.3604H108.001V50H94.916V47.3604Z",
    fill: "#007CC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.184 50L88.0851 47.3604H85.9043L86.7923 50H87.184Z",
    fill: "#007CC3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_388_6421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 63,
    fill: "#B3BACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_6421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 38,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner6);
export default __webpack_public_path__ + "static/media/partner-6.98f6d1185865e0a98ccaa650fbfe9daf.svg";
export { ForwardRef as ReactComponent };